import BaseApiRepository from './baseApiRepository'
import VehicleTypeRepository from './vehicleTypeRepository'
import RequestRepository from './requestRepository'
import PhotoRepository from './PhotoRepository'
import axios, { AxiosRequestConfig, AxiosInstance, AxiosResponse } from 'axios'


export enum Repositories {
  Base = 'base',
  Vehicle = 'vehicle',
  Request = 'request',
  Photo = 'photo'
}

export class RepositoryFactory {

  // Base repository only available for testing purposes
  private static repositories: any = {}

  public static get (name: Repositories) : any {
    const repository = this.repositories[name]

    if (!repository) {
      let newRepository: any

      switch (name) {
      case Repositories.Vehicle: {
        newRepository = new VehicleTypeRepository()
        break
      }
      case Repositories.Request: {
        newRepository = new RequestRepository()
        break
      }
      case Repositories.Photo: {
        newRepository = new PhotoRepository()
        break
      }
      }

      this.repositories[name] = newRepository
      return newRepository
    }

    return repository
  }
}
